import { useEffect, useState } from 'react';

// Matches the layout's mobile breakpoint (Tailwind `md`), as CentralChatRail does.
const NARROW_BREAKPOINT = 768;

/** True under the `md` breakpoint; follows a window resize. */
export function useNarrowScreen(): boolean {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < NARROW_BREAKPOINT,
  );
  useEffect(() => {
    const check = () => setNarrow(window.innerWidth < NARROW_BREAKPOINT);
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return narrow;
}

/** The window's inner width, following resizes. */
export function useViewportWidth(): number {
  const [width, setWidth] = useState(() => (typeof window !== 'undefined' ? window.innerWidth : 1280));
  useEffect(() => {
    const update = () => setWidth(window.innerWidth);
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);
  return width;
}
